"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var monitoring_1 = require("../../services/monitoring");
var AlertCenter = /** @class */ (function (_super) {
    __extends(AlertCenter, _super);
    function AlertCenter(props) {
        var _this = _super.call(this, props) || this;
        _this.nextAlert = function () {
            var _a = _this.state, currentAlertIndex = _a.currentAlertIndex, numberOfAlerts = _a.numberOfAlerts;
            if (currentAlertIndex === numberOfAlerts - 1) {
                _this.setState({ currentAlertIndex: 0 });
            }
            else {
                _this.setState({ currentAlertIndex: currentAlertIndex + 1 });
            }
        };
        _this.previousAlert = function () {
            var _a = _this.state, currentAlertIndex = _a.currentAlertIndex, numberOfAlerts = _a.numberOfAlerts;
            if (currentAlertIndex === 0) {
                _this.setState({ currentAlertIndex: numberOfAlerts - 1 });
            }
            else {
                _this.setState({ currentAlertIndex: currentAlertIndex - 1 });
            }
        };
        _this.previousAlertIndex = function (currentAlertIndex) {
            if (currentAlertIndex === 0) {
                return _this.state.numberOfAlerts - 1;
            }
            else {
                return currentAlertIndex - 1;
            }
        };
        _this.nextAlertIndex = function (currentAlertIndex) {
            if (currentAlertIndex === _this.state.numberOfAlerts - 1) {
                return 0;
            }
            else {
                return currentAlertIndex + 1;
            }
        };
        _this.state = {
            currentAlertIndex: 0,
            numberOfAlerts: 0
        };
        return _this;
    }
    AlertCenter.prototype.componentDidMount = function () {
        monitoring_1.default('alertCenter');
        var numberOfAlerts = React.Children.count(this.props.children);
        this.setState({ numberOfAlerts: numberOfAlerts });
    };
    AlertCenter.prototype.componentWillReceiveProps = function (nextProps) {
        var numberOfAlerts = React.Children.count(nextProps.children);
        if (numberOfAlerts - 1 < this.state.currentAlertIndex) {
            this.setState({ numberOfAlerts: numberOfAlerts, currentAlertIndex: numberOfAlerts - 1 });
        }
        else if (numberOfAlerts <= 1) {
            this.setState({ numberOfAlerts: numberOfAlerts, currentAlertIndex: 0 });
        }
        else {
            this.setState({ numberOfAlerts: numberOfAlerts });
        }
    };
    AlertCenter.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style;
        var _b = this.state, currentAlertIndex = _b.currentAlertIndex, numberOfAlerts = _b.numberOfAlerts;
        var Alerts = React.Children.map(this.props.children, function (child, index) {
            // Generate the navigation controls that will be injected into the <Alert/> elements
            var navigation, alertClassNames;
            // Only add navigation when the numberOfAlerts is greater than 1
            if (numberOfAlerts > 1) {
                navigation = (React.createElement(AlertCenterNavigation, { currentAlertIndex: index, numberOfAlerts: numberOfAlerts, previousAlert: this.previousAlert, nextAlert: this.nextAlert }));
            }
            // Apply classNames based on the currentAlertIndex
            if (index === currentAlertIndex) {
                alertClassNames = classNames('alert--current', child.props.className);
            }
            else if (index === this.nextAlertIndex(currentAlertIndex)) {
                alertClassNames = classNames('alert--next', child.props.className);
            }
            else if (index === this.previousAlertIndex(currentAlertIndex)) {
                alertClassNames = classNames('alert--previous', child.props.className);
            }
            else {
                alertClassNames = classNames('alert--overlaid', child.props.className);
            }
            return React.cloneElement(child, {
                className: alertClassNames,
                children: navigation
            });
        }.bind(this));
        // Disabling the stacked Alerts for now until the animation is settled and fine tuned.
        // const classes = classNames(
        //   'alert-center',
        //   { 'alert-center--multiple-showing': numberOfAlerts > 1 },
        //   className
        // )
        // return <div className={classes}>{Alerts}</div>
        var classes = classNames('alert-center', 'alert-center--simple', className);
        return (React.createElement("div", { className: classes, style: style }, this.props.children));
    };
    return AlertCenter;
}(React.Component));
exports.default = AlertCenter;
var AlertCenterNavigation = function (props) {
    return (React.createElement("div", { className: "alert-center__navigation" },
        React.createElement("i", { onClick: props.previousAlert, className: "fa fa-chevron-left", "aria-hidden": "true" }),
        React.createElement("span", null,
            props.currentAlertIndex + 1,
            "\u00A0\u00A0of\u00A0\u00A0",
            props.numberOfAlerts),
        React.createElement("i", { onClick: props.nextAlert, className: "fa fa-chevron-right", "aria-hidden": "true" })));
};
//# sourceMappingURL=AlertCenter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/AlertCenter/AlertCenter.js
// module id = 250
// module chunks = 0